import { useMemo } from 'react';
import { DayPicker, DateRange } from 'react-day-picker';
import 'react-day-picker/dist/style.css';

type Props = {
  from: string;
  to: string;
  onChange: (from: string, to: string) => void;
};

function toYMD(date: Date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
}

// Evita los desfaces por zona horaria que ocurren con new Date('YYYY-MM-DD')
function parseYMDLocal(value?: string): Date | undefined {
  if (!value) return undefined;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return undefined;
  const y = Number(match[1]);
  const m = Number(match[2]) - 1; // 0-based
  const d = Number(match[3]);
  return new Date(y, m, d);
}

export default function DateRangePicker({ from, to, onChange }: Props) {
  const selected = useMemo<DateRange | undefined>(() => {
    const fromDate = parseYMDLocal(from);
    const toDate = parseYMDLocal(to);
    if (!fromDate && !toDate) return undefined;
    return { from: fromDate, to: toDate };
  }, [from, to]);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-2">
      <DayPicker
        mode="range"
        selected={selected}
        onSelect={(range) => {
          const nextFrom = range?.from ? toYMD(range.from) : '';
          const nextTo = range?.to ? toYMD(range.to) : '';
          onChange(nextFrom, nextTo);
        }}
        weekStartsOn={1}
        captionLayout="dropdown"
        numberOfMonths={1}
        styles={{
          day: { fontSize: '0.85rem' },
        }}
      />
      <div className="mt-2 text-xs text-gray-600 px-1">
        Selección: {from || '-'} {from !== to ? `→ ${to || '-'}` : ''}
      </div>
    </div>
  );
}

